import NavComponent from "../lib/nav_component";

export const PanesComponentConfig = {
    baseHtmlClass: 'nav__panes',
    selector: '.nav__panes',
};

export class PanesComponent extends NavComponent {

    constructor(id_or_element, panesManager) {
        super(id_or_element, PanesComponentConfig);
        this.panesManager = panesManager;
    }

    render() {
        this.conditionallySetHtmlClassState(this.panesManager.readInternalStateValue('focusingPrimaryPane'), 'focus_primary');
        this.conditionallySetHtmlClassState(this.panesManager.readInternalStateValue('focusingSecondaryPane'), 'focus_secondary');
    }

}